export default {
	preventKeys(e, { format }) {
		let index = e.target.selectionStart;
		let prevent = true;

		function isAllowed(char, key) {
			switch (char) {
			case '9':
				return /[0-9]/.test(key);
			case 's':
				return /[a-z]/.test(key);
			case 'S':
				return /[A-Z]/.test(key);
			case '*':
				return true;
			}
		}

		for (let i = index; i < format.length; i++) {
			if (isAllowed(format[i], e.key)) {
				prevent = false;
				break;
			}
		}

		if (prevent) {
			e.preventDefault();
		}
	},

	getMaskSpecialChars({ format, inverse }) {
		let specialChars = [];

		format = [...format];

		if (inverse) {
			format.reverse();
		}

		format.forEach((char, index) => {
			if (['s', 'S', '9', '*'].indexOf(char) === -1) {
				specialChars.push({ index, char });
			}
		});

		return specialChars;
	},

	maskit({ format, inverse }, value) {
		let specialChars = this.getMaskSpecialChars({ format, inverse });

		value = this.unmaskit({ format, inverse }, value);

		value = [...value];

		if (inverse) {
			value.reverse();
		}

		specialChars.forEach(sc => {
			if (value.length > sc.index) {
				value.splice(sc.index, 0, sc.char);
			}

			if (inverse && value.length === sc.index) {
				value.splice(sc.index, 0, sc.char);
			}
		});

		if (inverse) {
			value.reverse();
		}

		value = value.join('');

		return value;
	},

	unmaskit({ format, inverse }, value) {
		let specialChars = this.getMaskSpecialChars({ format, inverse });

		specialChars.forEach(sc => {
			value = value.toString().replace(sc.char, '');
		});

		return value;
	}
};


// WEBPACK FOOTER //
// ./application/components/form/masker.js